import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "contact-card" }
const _hoisted_2 = { class: "contact-card--details contact" }
const _hoisted_3 = { class: "contact--name subtitle-02" }
const _hoisted_4 = { class: "contact--position type-button-02" }
const _hoisted_5 = {
  key: 0,
  class: "contact--break"
}
const _hoisted_6 = {
  key: 1,
  class: "contact--telephone"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 2,
  class: "contact--email"
}
const _hoisted_9 = {
  key: 3,
  class: "contact-links"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 4,
  class: "contact-groups-edit"
}
const _hoisted_12 = {
  key: 5,
  class: "contact--message"
}
const _hoisted_13 = { class: "title-text type-subtitle-04" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 6,
  class: "contact--bio"
}
const _hoisted_16 = { class: "title-text type-subtitle-04" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 7,
  class: "contact--chat"
}
const _hoisted_19 = { key: 8 }
const _hoisted_20 = { class: "contact--groups" }
const _hoisted_21 = { class: "title-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 'edit')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "remove-card",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleRemove && _ctx.handleRemove(...args)))
        }, " × "))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "contact-card--image",
      style: _normalizeStyle({
        '--image': `url('${_ctx.contact.image ? _ctx.contact.image : _ctx.noImage}')`,
      })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.contact.name), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.contact.position), 1),
      (
          _ctx.contact.telephone ||
          _ctx.contact.email ||
          (_ctx.contact.links && _ctx.contact.links.length)
        )
        ? (_openBlock(), _createElementBlock("span", _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.contact.telephone)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _createElementVNode("a", {
              href: `tel:${_ctx.convertTel(_ctx.contact.telephone)}`
            }, _toDisplayString(_ctx.contact.telephone), 9, _hoisted_7)
          ]))
        : _createCommentVNode("", true),
      (_ctx.contact.email)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
            _createVNode(_component_Button, {
              text: "",
              size: "sm",
              variant: "gradient-02",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendEmail(_ctx.contact.email)))
            }, {
              labelBefore: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "envelope" }),
                _cache[3] || (_cache[3] = _createTextVNode(" Email me ", -1))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.contact.links && _ctx.contact.links.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "contact--break" }, null, -1)),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.links, (link, sidx) => {
                return (_openBlock(), _createElementBlock("li", { key: sidx }, [
                  _createElementVNode("a", {
                    href: _ctx.getFullLink(link),
                    target: "_blank",
                    class: "contact-links--link"
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.getFAIcon(link)
                    }, null, 8, ["icon"])
                  ], 8, _hoisted_10)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.mode === 'edit')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "contact--break" }, null, -1)),
            _createVNode(_component_MultiSelect, {
              value: _ctx.selectedGroups,
              label: "form.groups",
              name: "groups",
              id: "groups",
              items: _ctx.groupOptions,
              onChange: _ctx.handleGroupChange
            }, null, 8, ["value", "items", "onChange"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.contact.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "contact--break" }, null, -1)),
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_TranslatedText, { path: "track.contact.description-title" })
            ]),
            _createElementVNode("span", {
              class: "content-text type-body-04",
              innerHTML: _ctx.contact.description
            }, null, 8, _hoisted_14)
          ]))
        : _createCommentVNode("", true),
      (_ctx.contact.bio)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "contact--break" }, null, -1)),
            _createElementVNode("span", _hoisted_16, [
              _createVNode(_component_TranslatedText, { path: "track.contact.bio" })
            ]),
            _createElementVNode("span", {
              class: "content-text type-body-04",
              innerHTML: _ctx.contact.bio
            }, null, 8, _hoisted_17)
          ]))
        : _createCommentVNode("", true),
      (_ctx.contact.userId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_Button, {
              text: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendChat(_ctx.contact.userId)))
            }, {
              labelBefore: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "comment-dots" }),
                _cache[8] || (_cache[8] = _createTextVNode(" Chat now ", -1))
              ]),
              _: 1
            })
          ]))
        : (_ctx.mode === 'sedit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, [
                  _createVNode(_component_TranslatedText, { path: "track.contact.contact-groups" })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}